import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"
import EngagingMenuPageStyle from "./engaging-menu-page.module.scss"

/*
 * This component is built using `gatsby-image` to automatically serve optimized
 * images with lazy loading and reduced file sizes. The image is loaded using a
 * `useStaticQuery`, which allows us to load the image from directly within this
 * component, rather than having to pass the image data down from pages.
 *
 * For more information, see the docs:
 * - `gatsby-image`: https://gatsby.dev/gatsby-image
 * - `useStaticQuery`: https://www.gatsbyjs.org/docs/use-static-query/
 */

const EngagingMenuImgMobile = () => {
  const data = useStaticQuery(graphql`
    query {
      contentfulEngagingMenuPage{
        engagingMenuReference{
          hero{
            mobileHeroBgImage{
              fluid(maxWidth:500){
                ...GatsbyContentfulFluid
                }
              }
            }
          }
        }
    }
  `)

  return <Img alt="Engaging Mobile Restaurant Menu - First String Digital" className={EngagingMenuPageStyle.heroImgMobile} fluid={data.contentfulEngagingMenuPage.engagingMenuReference.hero.mobileHeroBgImage.fluid} />
}

export default EngagingMenuImgMobile
